import React, { useMemo } from "react";
import PropTypes from "prop-types";
import helpers from "helpers/base";

const Radio = ({
  checked = false,
  containerClassName = "lc-radio",
  disabled = false,
  inputData = {},
  onChange,
  label = null,
  name,
  value,
  children
}) => {
  const inputId = useMemo(() => helpers.generateComponentUuid("lc-radio"), []);

  const dataAttributes = useMemo(() => {
    const result = {};
    Object.keys(inputData || {}).forEach((key) => {
      result[`data-${key}`] = inputData[key];
    });
    return result;
  }, [inputData]);

  const handleChange = (e) => {
    if (onChange) onChange(e);
  };

  // For determining whether our component controls the checked state or the browser does.
  const isControlled = onChange !== undefined;

  return (
    <div className={containerClassName}>
      <input
        {...dataAttributes}
        className="lc-radio__input"
        {...(isControlled ? { checked } : { defaultChecked: checked })}
        disabled={disabled}
        id={inputId}
        name={name}
        type="radio"
        value={value}
        onChange={handleChange}
      />
      <label className="lc-radio__label" htmlFor={inputId}>
        {label || children}
      </label>
    </div>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  inputData: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired
};

export default Radio;
